<template>
  <div class="xcar pb-0 mb-0 mx-1">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center mt-0 pt-0 mb-0">
      CERTIFICACIONES - OPCIONES DE FILTRO
    </h4>
    <p class="text-center blue--text">El convenio no afecta a este reporte.</p>

    <v-row dense class="ml-2">
      <v-col cols="2">
        <v-combobox
          v-model="filtros.gestion"
          :items="gestiones"
          label="Gestion"
          :disabled="loading"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox
          v-model="filtros.mes"
          :items="meses"
          label="Mes"
          :disabled="loading"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox
          v-model="filtros.unidad"
          :items="unidades"
          label="Unidad de negocio"
          :disabled="loadingunidades || loading"
          :loading="loadingunidades"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox
          v-model="filtros.sede"
          :items="sedes"
          label="Sede"
          :disabled="loadingsedes || loading"
          :loading="loadingsedes"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="4">
        <v-combobox
          v-model="filtros.programa"
          :items="programas"
          label="Programa"
          :disabled="loadingprogramas || loading"
          :loading="loadingprogramas"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
    </v-row>

    <div><AAsignacionTablaC ref="asignacionestablar" v-on:dataloaded="dataloaded" /></div>
    <p class="text-center text-danger pa-0" v-if="msg">
      <b>{{ msg }}</b>
    </p>
    <div class="text-center ma-0" v-if="loading">
      <div style="display: inline-block;" v-if="loading" class="loader"></div>
    </div>
  </div>
</template>

<script>
  import AAsignacionTablaC from '@/components/AAsignacionTablac.vue';
  import gql from 'graphql-tag';

  export default {
    data() {
      return {
        msg: '',
        loading: false,
        loadingunidades: false,
        loadingsedes: false,
        loadingprogramas: false,
        gestiones: [2024,2023,2022, 2021, 2020, 2019, 2018],
        meses: [
          { id: 1, text: 'Enero' },
          { id: 2, text: 'Febrero' },
          { id: 3, text: 'Marzo' },
          { id: 4, text: 'Abril' },
          { id: 5, text: 'Mayo' },
          { id: 6, text: 'Junio' },
          { id: 7, text: 'Julio' },
          { id: 8, text: 'Agosto' },
          { id: 9, text: 'Septiembre' },
          { id: 10, text: 'Octubre' },
          { id: 11, text: 'Noviembre' },
          { id: 12, text: 'Diciembre' },
        ],
        unidades: [],
        sedes: [],
        programas: [],
        filtros: {
          gestion: null,
          mes: null,
          unidad: null,
          sede: null,
          programa: null,
        },
      };
    },
    components: { AAsignacionTablaC },
    watch: {
      'filtros.gestion': function() {
        if (this.filtros.gestion) this.listarsignaciones();
      },
      'filtros.mes': function() {
        if (this.filtros.mes) this.listarsignaciones();
      },
      'filtros.unidad': function() {
        if (this.filtros.unidad) this.getsedes();
      },
      'filtros.sede': function() {
        if (this.filtros.unidad) this.getprogramas();
      },
      'filtros.programa': function() {
        if (this.filtros.unidad) this.listarsignaciones();
      },
    },
    methods: {
      listarsignaciones() {
        if (!this.filtros.gestion) return;
        if (!this.filtros.mes) return;
        if (!this.filtros.unidad) return;
        let anio = this.filtros.gestion;
        let mes = this.filtros.mes.id;
        let unidad = this.filtros.unidad.id;
        let sede = this.filtros.sede;
        let programa = this.filtros.programa;
        this.$refs.asignacionestablar.resetasignaciones();
        if (this.loading) return;
        this.loading = true;
        this.$refs.asignacionestablar.obtenerasignaciones(mes, anio, unidad, sede, programa);
      },
      //total, deuda, importe, saldo
      async getunidades() {
        var vue = this;
        this.$refs.asignacionestablar.resetasignaciones();
        this.filtros.unidad = null;
        this.loadingunidades = true;
        this.filtros.sede = null;
        this.filtros.programa = null;
        this.sedes = [];
        this.programas = [];
        let xsql = 'query { NegociosAll {   id   nombre } }';
        var sql = gql`
          ${xsql}
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var dat = data.data.NegociosAll;
            dat.map((x) => {
              x.text = x.nombre;
            });
            vue.unidades = dat;
            vue.loadingunidades = false;
            let unidad = vue.$store.state.CARGO.sede.unidad_negocio;
            vue.filtros.unidad = dat.find((u) => u.id == unidad);
          })
          .catch((error) => {
            vue.loadingunidades = false;
            window.console.error(error);
          });
      },
      async getsedes() {
        if (!this.filtros.unidad) return;
        this.$refs.asignacionestablar.resetasignaciones();
        this.filtros.sede = null;
        if (this.sedes.length > 0) {
          this.listarsignaciones();
          return;
        }
        var vue = this;
        this.filtros.programa = null;
        this.sedes = [];
        this.programas = [];
        this.loadingsedes = true;
        let xsql = 'query { getSedes(unidad_negocio_id:' + this.filtros.unidad.id + ') {   id   nombre } }';
        window.console.log(xsql);
        var sql = gql`
          ${xsql}
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var dat = data.data.getSedes;
            window.console.log(data.data.getSedes);
            dat.map((x) => {
              x.text = x.nombre;
            });
            vue.sedes = dat;
            vue.loadingsedes = false;
            vue.listarsignaciones();
          })
          .catch((error) => {
            vue.loadingsedes = false;
            window.console.error(error);
          });
      },
      async getprogramas() {
        this.$refs.asignacionestablar.resetasignaciones();
        if (!this.filtros.sede) {
          this.listarsignaciones();
          return;
        }
        var vue = this;
        this.filtros.programa = null;
        this.programas = [];
        this.loadingprogramas = true;
        let xsql =
          'query { getProgramas(idsede:' +
          this.filtros.sede.id +
          ',gestion:' +
          this.filtros.gestion +
          ') {   id,codigo,nombre_compuesto } }';
        var sql = gql`
          ${xsql}
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var dat = data.data.getProgramas;
            dat.map((x, i) => {
              if (!x.codigo) x.codigo = '';
              x.text = `${i}. ${x.nombre_compuesto} [${x.codigo}]`;
            });
            vue.programas = dat;
            vue.loadingprogramas = false;
            vue.listarsignaciones();
          })
          .catch((error) => {
            vue.loadingprogramas = false;
            window.console.error(error);
          });
      },
      defaultdata() {
        let date = new Date();
        let anio = date.getFullYear();
        let mes = date.getMonth() + 1;
        this.filtros.gestion = '' + anio;
        this.filtros.mes = this.meses.find((x) => x.id == mes);
      },
      dataloaded() {
        this.loading = false;
      },
    },
    mounted() {
      this.getunidades();
      this.defaultdata();
    },
  };
</script>
